import { css } from '@emotion/react';

import { COLORS } from '~/styles/colors';

export const useStyles = () => {
  return {
    header: css`
      display: flex;
      align-items: center;
      gap: 12px;
    `,
    iconContainer: css`
      background-color: ${COLORS.blue50};
      padding: 6px;
      border-radius: 12px;
      width: 46px;
      height: 46px;
    `,
  };
};
